import React from "react";
import { FormInstance } from "rc-field-form";
import { atom } from "jotai";

export const EditableContext = React.createContext<FormInstance<any> | null>(
    null
);

//判断是否有必填项未输入值
export const isRequiredAtom = atom(false);
